<template>
  <Layout>
    <template v-slot:title>Demasiadas Peticiones al Servidor</template>
    <p>
      Lo sentimos, pero se ha superado el número máximo de peticiones al
      servidor. Por favor, inténtalo de nuevo dentro de una hora.
    </p>
  </Layout>
</template>

<script>
import Layout from '@/layouts/ErrorLayout'

export default {
  components: { Layout },
}
</script>
